import { fetchSortitionParams } from '@/api/sortitionDisplay.api';
import Validatable from '../../../mixins/Validatable.js';
import ContentLoader from '../../../mixins/ContentLoader.js';
import SortitionForm from '../../../components/sortitionDisplay/SortitionForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
	components: {
		SortitionForm,
		ValidationObserver
	},
	mixins: [Validatable, ContentLoader],
	data() {
		return {
			sortition: {
				name: '',
				order: null,
				schedules: [],
				resultFields: [],
				logo: null,
				background: null,
				lotteryId: ''
			},
			params: {
				weekdays: [],
				resultFields: [],
				lotteries: [],
				servers: []
			}
		};
	},
	methods: {
		async fetchParams() {
			try {
				const response = await fetchSortitionParams(),
					{ weekdays, resultFields, lotteries, servers } = response.data;

				this.params.weekdays = weekdays;
				this.params.resultFields = resultFields;
				this.params.lotteries = lotteries;
				this.params.servers = servers;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
